import { useNavigate } from "react-router-dom";
import { HomeString } from "../../utils/string";
import SingleLineSkeleton from "../loader/skeleton/singleLineSkeleton";
import NoCategoriesAvailable from "./noCategoriesAvailable";

const Categories = ({ List, isLoader }) => {
  let navigate = useNavigate();
  const PavingMarketCategories = List.find((item) => item.AssetTypeId === 2);
  return (
    <>
      <div className="bg-[#F2F2F2] py-[21px] pb-[60px]">
        <div className="custom-container">
          {/* <div className="text-[28px] md:text-[48px] font-bold text-center mb-[24px]  text-[#161412]">
            {HomeString.CATEGORIES}
          </div> */}

          <div className="grid grid-cols-4 gap-x-10 max-[1196px]:grid-cols-2 max-[842px]:grid-cols-1 mx-auto">
            {isLoader ? (
              Array.from({ length: 18 }).map((_, index) => <SingleLineSkeleton key={index} />)
            ) : PavingMarketCategories?.CategoryDetails?.length <= 0 || !PavingMarketCategories?.CategoryDetails ? (
              <div className="h-[300px] flex items-center justify-center max-[1196px]:col-span-2 max-[842px]:col-span-1 col-span-3">
                <NoCategoriesAvailable />
              </div>
            ) : (
              PavingMarketCategories?.CategoryDetails?.map((listItem) => {
                return (
                  <div
                    className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px] cursor-pointer"
                    onClick={() => {
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                      navigate(`/search`, {
                        state: {
                          keywords: null,
                          selectMake: null,
                          selectCategory: JSON.stringify([listItem]),
                        },
                      });
                    }}
                  >
                    {listItem.CategoryName}
                  </div>
                );
              })
            )}
            {/* <div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Track_Pavers}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.E_Rubber_Tired_Pavers}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Track_Paver}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Rubber_Tired_Pavers}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Asphalt_Distributors}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Asphalt_Plants}
              </div>
            </div>
            <div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Brooms}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Chip_Spreaders}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Compaction}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Concrete}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Crushers}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Force_Feed_Loaders}
              </div>
            </div>
            <div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Milling_Machines}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Material_Transfer_Vehicles}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Miscellaneous}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Reclaimers_Stabilizers}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Road_Wideners}
              </div>
              <div className="text-[20px] md:text-[24px] text-[#161412] font-medium leading-[30px]">
                {HomeString.Striping}
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};
export default Categories;
